function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useState } from 'react';
import UserPanel from 'moduleBase/components/header/user-panel/UserPanel';
import SvgSprite from 'src/react/components/html-elements/SvgSprite';
import MobileNav from 'moduleBase/modules/menu/containers/MobileNav';
import { Collapse } from 'react-bootstrap';
import Logo from 'images/logo.svg';
import { When } from 'react-if';
import CartNotifier from 'moduleCartNotifier/containers/CartNotifier';
import { Link } from 'components/router/Link';
import { Avatar } from 'ui/avatar/Avatar';
import { useUserData } from 'components/user/hooks/use-user-data';
import Notifier from 'moduleChatNotifier/containers/Notifier';

var MobileHeader = function MobileHeader(_ref) {
  var userMenu = _ref.userMenu;
  var userData = useUserData();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisibleMenuPanel = _useState2[0],
      setIsVisibleMenuPanel = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisibleUserPanel = _useState4[0],
      setIsVisibleUserPanel = _useState4[1];

  var userPanelShow = function userPanelShow() {
    setIsVisibleUserPanel(!isVisibleUserPanel);
    document.body.classList.toggle('body-fixed');

    if (isVisibleMenuPanel) {
      setIsVisibleMenuPanel(false);
      document.body.classList.add('body-fixed');
    }
  };

  var menuPanelShow = function menuPanelShow() {
    setIsVisibleMenuPanel(!isVisibleMenuPanel);
    document.body.classList.toggle('body-fixed');

    if (isVisibleUserPanel) {
      setIsVisibleUserPanel(false);
      document.body.classList.add('body-fixed');
    }
  }; // noinspection HtmlUnknownTarget


  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("header", {
    className: "site-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container container-lg-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "site-header__menu-toggle btn btn-square collapsed",
    type: "button",
    onClick: menuPanelShow
  }, /*#__PURE__*/React.createElement(SvgSprite, {
    id: "menu-open",
    size: 16
  })), /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: "mr-16p"
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    className: "img-fluid"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mr-16p ml-auto"
  }, /*#__PURE__*/React.createElement(Notifier, null)), /*#__PURE__*/React.createElement(When, {
    condition: userData.isCustomer
  }, /*#__PURE__*/React.createElement(CartNotifier, null)), /*#__PURE__*/React.createElement("button", {
    className: "site-header__user-panel-toggle btn rounded-circle collapsed",
    type: "button",
    onClick: userPanelShow
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: userData.avatar.image,
    sizeSm: true
  }))))), /*#__PURE__*/React.createElement(Collapse, {
    "in": isVisibleMenuPanel
  }, /*#__PURE__*/React.createElement("div", {
    className: "menu-panel shadow-bottom"
  }, /*#__PURE__*/React.createElement(MobileNav, {
    hide: function hide() {
      setIsVisibleMenuPanel(false);
      document.body.classList.remove('body-fixed');
    }
  }))), /*#__PURE__*/React.createElement(UserPanel, {
    isVisible: isVisibleUserPanel,
    userMenu: userMenu,
    hide: function hide() {
      setIsVisibleUserPanel(false);
      document.body.classList.remove('body-fixed');
    }
  }));
};

export default MobileHeader;